import translations from '../../../../../public/data/translations.json'

export const getSearchAsUrl = (category, baseAs, locale = 'ME') => {
  if (category) return `${baseAs}/${category}/${translations.pretraga[locale]}`

  return `${baseAs}${translations.pretraga[locale]}`
}
